// Single source of truth for the public Gallery page images.
// Imported by BOTH the Gallery page (to render) and the admin Media Map
// (to list + override them), so the two can never drift - every image the
// gallery shows is guaranteed to be visible and swappable in the Media Map.

import { properties } from '@/data/property-catalog';

export type GallerySource = "instagram" | "skycabin" | "levikka" | "varakka" | "pikupoikka" | "isopoikka" | "mestari" | "iso-yllas";

export interface GalleryItem {
  id: string;
  src: string;
  alt: string;
  source: GallerySource;
}

function seq<T>(count: number, make: (n: number, padded: string) => T): T[] {
  return Array.from({ length: count }, (_, idx) => {
    const n = idx + 1;
    return make(n, String(n).padStart(2, "0"));
  });
}

export const GALLERY_ITEMS: GalleryItem[] = [
  ...properties.filter(cabin => cabin.status === 'live').flatMap(cabin => cabin.images.map((src, i) => ({
    id: `${cabin.slug}-${i + 1}`,
    src,
    alt: `${cabin.name} — Photo ${i + 1}`,
    source: (cabin.slug === 'iso-yllas' ? cabin.slug : cabin.slug.split('-')[0]) as GallerySource,
  }))),
  ...seq(103, (i, num) => ({
    id: `ig-${num}`,
    src: `/images/gallery/gallery-${num}.jpg`,
    alt: `Kettura Finland - Photo ${i}`,
    source: "instagram" as const,
  })),
];
